import { mutator } from 'satcheljs';
import {
    onAvailableRetentionPoliciesListSucceeded,
    resetRetentionPoliciesEdit,
    enableDisableRetentionPolicy,
    deleteRetentionPolicyRow,
    onAddActivePolicyTagsRequestComplete,
    onRetentionPoliciesFullInitialized,
} from '../actions/internalActions';
import { ObservableMap } from 'mobx';
import getAvailablePoliciesListState from '../selectors/getAvailablePoliciesListState';

mutator(onAvailableRetentionPoliciesListSucceeded, actionMessage => {
    const { policies, policyRowIds } = actionMessage;
    const availablePolicies = getAvailablePoliciesListState();
    availablePolicies.retentionPolicies = new ObservableMap(policies);
    availablePolicies.retentionPolicyIds = policyRowIds;
    // Since we have updated the policy data now with the latest values, update the isStale value
    availablePolicies.isStale = false;
});

mutator(resetRetentionPoliciesEdit, () => {
    const availablePolicies = getAvailablePoliciesListState();
    availablePolicies.retentionPolicies.forEach(policy => (policy.isChecked = false));
});

mutator(enableDisableRetentionPolicy, actionMessage => {
    const { retentionId, isChecked } = actionMessage;
    const retentionPolicyRow = getAvailablePoliciesListState().retentionPolicies.get(retentionId);
    retentionPolicyRow.isChecked = isChecked;
});

mutator(deleteRetentionPolicyRow, actionMessage => {
    const availablePolicies = getAvailablePoliciesListState();
    availablePolicies.isStale = true;
});

mutator(onAddActivePolicyTagsRequestComplete, () => {
    const availablePolicies = getAvailablePoliciesListState();
    availablePolicies.isStale = true;
});

mutator(onRetentionPoliciesFullInitialized, () => {
    const availablePolicies = getAvailablePoliciesListState();
    availablePolicies.isStale = true;
});
